import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { OutdatedTaxCategoryWarning as UnifiedOutdatedTaxCategoryWarning } from './OutdatedTaxCategoryWarning'
import { OutdatedTaxCategoryWarningLegacy } from './OutdatedTaxCategoryWarningLegacy'
import { OutdatedTaxCategoryWarningProps } from './useOutdatedTaxCategoryWarningModel'

export const OutdatedTaxCategoryWarning: React.FC<OutdatedTaxCategoryWarningProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <UnifiedOutdatedTaxCategoryWarning {...props} />
  ) : (
    <OutdatedTaxCategoryWarningLegacy {...props} />
  )
}
